import React, { Fragment, useState, useRef, useEffect } from "react";
import CssTransition from "../layout/css-transition";
import { Menu, Transition, Switch } from "@headlessui/react";

function CheckboxFilter({ checkboxData, button, handleCheckboxChange }) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const trigger = useRef(null);
  const dropdown = useRef(null);

  const count = Object.values(checkboxData).flat().filter(item => item.checked)?.length;

  // close on click outside
  useEffect(() => {
    const clickHandler = ({ target }) => {
      if (!dropdown.current) return;
      if (
        !dropdownOpen ||
        dropdown.current.contains(target) ||
        trigger.current.contains(target)
      )
        return;
      setDropdownOpen(false);
    };
    document.addEventListener("click", clickHandler);
    return () => document.removeEventListener("click", clickHandler);
  });

  // close if the esc key is pressed
  useEffect(() => {
    const keyHandler = ({ keyCode }) => {
      if (!dropdownOpen || keyCode !== 27) return;
      setDropdownOpen(false);
    };
    document.addEventListener("keydown", keyHandler);
    return () => document.removeEventListener("keydown", keyHandler);
  });

  return (
    <div className="relative">
      {count > 0 && <div className="absolute -top-2 -right-3 w-5 h-5 bg-[--bg-color-500] border-2 border-white rounded-full text-[10px] text-white font-bold flex justify-center items-center">{count}</div>}
      {button ? (
        <button
          ref={trigger}
          onClick={(e) => setDropdownOpen(!dropdownOpen)}
          className="btn bg-white border bborder-slate-[#E7E7E7] hover:border-slate-300 text-[#1E293B] text-sm font-medium leading-5"
        >
          Filters
        </button>
      ) : (
        <span
          ref={trigger}
          className="fal fa-sliders-h text-lg cursor-pointer"
          onClick={(e) => setDropdownOpen(!dropdownOpen)}
        ></span>
      )}
      <CssTransition
        show={dropdownOpen}
        tag="div"
        className="w-[250px] bg-white absolute top-full left-1/2 transform -translate-x-1/2 px-4 py-2 rounded shadow-md z-60"
        enter="transition ease-out duration-100 transform"
        enterStart="opacity-0 -translate-y-2"
        enterEnd="opacity-100 translate-y-0"
        leave="transition ease-out duration-100"
        leaveStart="opacity-100"
        leaveEnd="opacity-0"
      >
        <div
          ref={dropdown}
          className="font-medium text-sm text-slate-600 space-y-4 !z-[1000]"
          onFocus={() => setDropdownOpen(true)}
        >
          {Object.keys(checkboxData).map((checkboxKey, index) => {
            return (
              <div key={checkboxKey} className="space-y-2 !z-[1000]">
                <h4 className="text-sm leading-4 tracking-tight font-bold text-[#535860]">
                  {checkboxKey}
                </h4>
                <div className="space-y-2">
                  {checkboxData[checkboxKey].map((checkboxVal, i) => {
                    return (
                      <div key={checkboxVal.value} className="mr-1">
                        <div className="flex items-center">
                          <input
                            id={checkboxVal.value}
                            type="checkbox"
                            className="form-checkbox"
                            checked={checkboxVal.checked}
                            onChange={() =>
                              handleCheckboxChange(i, checkboxKey)
                            }
                          />
                          <label
                            htmlFor={checkboxVal.value}
                            className="text-sm ml-2 text-[#535860] tracking-tight leading-3 font-light cursor-pointer"
                          >
                            {checkboxVal.label}
                          </label>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </CssTransition>
    </div>
  );
}

export const ToggleFilter = ({
  toggleData,
  handleToggleChange,
  isTableChange,
  setIsTableChange,
}) => {
  return (
    <Menu as="div" className="relative inline-block text-center">
      <div>
        <Menu.Button className="inline-flex w-full justify-center rounded-md  px-4 py-2 text-sm font-medium focus:outline-none">
          <span class="fa-regular fa-plus-large cursor-pointer"></span>
        </Menu.Button>
      </div>
      <Transition
        as="div"
        enter="transition ease-out duration-100 z-[1000]"
        enterFrom="transform opacity-0 scale-95 z-[1000]"
        enterTo="transform opacity-100 scale-100 z-[1000]"
        leave="transition ease-in duration-75 z-[1000]"
        leaveFrom="transform opacity-100 scale-100 z-[1000]"
        leaveTo="transform opacity-0 scale-95 z-[1000]"
      >
        <Menu.Items className="z-[1000] absolute right-0 mt-2 w-56 max-h-96 overflow-y-auto origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none">
          {Object.keys(toggleData).map((toggleKey, index) => {
            return (
              <div key={toggleKey} className="px-1 py-2 space-y-1">
                <h4 className="text-[13px] leading-4 tracking-tight font-semibold text-[#94A3B8] p-2 text-left">
                  {toggleKey}
                </h4>
                <div className="space-y-2">
                  {toggleData[toggleKey].map((toggleVal, i) => {
                    return (
                      <div key={toggleVal.value} className="px-2">
                        <div className="flex items-center space-x-2">
                          <input
                            id={toggleVal.label}
                            type="checkbox"
                            className="form-checkbox"
                            checked={toggleVal.checked}
                            onChange={() => {
                              handleToggleChange(i, toggleKey);
                              setIsTableChange(isTableChange + 1);
                            }}
                          />
                          <label
                            htmlFor={toggleVal.label}
                            className="text-[13px] text-[#535860] tracking-tight leading-3 font-medium cursor-pointer"
                          >
                            {toggleVal.label}
                          </label>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </Menu.Items>
      </Transition>
    </Menu>
  );
};

export default CheckboxFilter;
